
import CloseIcon from '@mui/icons-material/Close';
import { AppBar, Button, Dialog, IconButton, Toolbar } from '@mui/material';
import moment from 'moment';
import React, { useEffect, useState } from 'react';
import { renderToString } from 'react-dom/server';
import { useTranslation } from 'react-i18next';

import { ROLES } from '../../config';
import { EmplacementEnum } from '../../data/Interfaces';
import { IconReplanification } from '../../data/SVGs';
import useCraRdv from '../../hooks/useCraRdv';
import useFormValidation from '../../hooks/useFormValidation';
import usePostRequest from '../../hooks/usePostRequest';
import useRole, { roleNameEnum } from '../../hooks/useRole';
import useUtilities from '../../hooks/useUtilities';
import useWindowSize from '../../hooks/useWindowSize';
import { isValidDate } from '../../Utils/utils';
import { buttonStyles, buttonStylesGreen } from '../docsAdministrative/JsObjectStyles';
//import GetZoomMeetingComponent from '../shared/GetZoomMeetingComponent';
import QuillAdvancedTextArea from '../shared/QuillAdvancedTextArea';
import { DatePickerComponent, SelectComponent, TextFieldComponent, Transition } from '../shared/ReusableSmallComponents';
// * les action qu'on peut faire d'apres le calendrier, apres avoir accepter le rdv
export const rdvActionsEnum = {
    accepte: 'accepte',
    replanifie: 'replanifie',
    rejete: 'rejete',
    annule: 'annule'
};

function DialogInterviewerCandidature() {
    const { setShowErrors, setErrors } = useUtilities();
    const { selectedRDV, setSelectedRDV, openNestedInterviewerCandidature, setOpenNestedInterviewerCandidature } = useCraRdv();
    // * expertId={selectedRDV?.candidatureId?.expertId?._id}
    // * FROM AO/Candidatures :
    // * aoId={selectedRDV?.candidatureId?.aoId?._id}
    // * FROM DOSSIER
    // * dossierId
    const [statusCandidature, setStatusCandidature] = useState(selectedRDV?.statusCandidature);
    // * we could have either aoId incase we came from AO, or dossierId incase we came from dossier
    const [aoId, setAoId] = useState(selectedRDV?.aoId);
    const [dossierId, setDossierId] = useState(selectedRDV?.dossierId);
    const [expertId, setExpertId] = useState(selectedRDV?.expertId);
    const {device}=useWindowSize();
    const { postData } = usePostRequest();
    const role = useRole();

    const [isReplanning, setIsReplanning] = useState(false);
    const [emplacement, setEmplacement] = useState(selectedRDV?.emplacement);
    const [note, setNote] = useState(selectedRDV?.note ?? '');
    const [dateRdv, setDateRdv] = useState(moment(selectedRDV?.date, 'DD-MM-YYYY hh:mm A'));
    const [heureFin, setHeureFin] = useState(selectedRDV?.heureFin);
    const [heureDebut, setHeureDebut] = useState(selectedRDV?.heureDebut);
    const { i18n } = useTranslation();
    const [zoomLink, setZoomLink] = useState('');
    const [isValid] = useFormValidation([
        { name: 'emplacement', value: emplacement },
        { name: 'date', value: dateRdv },
        { name: 'heureDebut', value: heureDebut },
        { name: 'heureFin', value: heureFin },
    ]);
    useEffect(() => {
        setEmplacement(selectedRDV?.emplacement);
        setNote(selectedRDV?.note);
        setHeureFin(selectedRDV?.heureFin);
        setHeureDebut(selectedRDV?.heureDebut);
        // * FROM RDV FORM TO DATE PICKER :
        isValidDate(selectedRDV?.date) && setDateRdv(moment(selectedRDV?.date, 'DD-MM-YYYY hh:mm A'));
        // FROM CANDIDATURES
        setStatusCandidature(selectedRDV?.statusCandidature);
        setExpertId(selectedRDV?.expertId);
        setAoId(selectedRDV?.aoId);
        setDossierId(selectedRDV?.dossierId);
    }, [selectedRDV]);

    useEffect(() => {
        if (zoomLink !== '') {
            let zoomHtmlLink = renderToString(
                <p>
                    <a
                        href={zoomLink}
                        rel="noopener noreferrer"
                        target="_blank"
                    >{zoomLink}</a></p>
            );
            // * used in the client side, th above one  is on the server side
            // ().outerHTML;
            if (note) {
                setNote((prev) => {
                    // console.log('88888', prev, zoomHtmlLink, `${prev} ${zoomHtmlLink}`);
                    return `${prev} ${zoomHtmlLink}`;
                });
            } else { setNote(zoomHtmlLink); }
        }
    }, [zoomLink]);

    //! hooks rule : call a hook only inside a functionnal component, don't try to create a function to prevent DRY ..

    const handleCloseNestedInterviewerCandidature = () => {
        // * clear states before closing
        // debugger;
        setSelectedRDV({});
        setIsReplanning(false);
        // setRdvAction('');
        setEmplacement(null);
        setNote(null);
        setHeureFin(null);
        setHeureDebut(null);
        isValidDate(null) && setDateRdv(null);
        setZoomLink('');
        setOpenNestedInterviewerCandidature(false);
    };

    const handleSendRdv = async (rdvActionParameter) => {
        // * on a change le status vers interviewer
        if (statusCandidature == 'interview') {
            await postData({
                url: '/candidature/planifierRDV', payload: {
                    emplacement,
                    // ?possible way : implicitly ( and we must add a delete btn in this case to delete the created meeting)
                    // note: note+ zoomLink,
                    // ? other way: explicitly: he must add the wanted link to the note (where we used the copy to clipboard option)
                    note,
                    date: dateRdv,
                    heureDebut,
                    heureFin,
                    expertId,
                    statusCandidature,
                    aoId,
                    dossierId,
                }
            });
            handleCloseNestedInterviewerCandidature();
        }
        // * collaborateur/admin parvient du calendrier
        else if (Object.keys(rdvActionsEnum).includes(rdvActionParameter)) {
            await postData({
                url: '/candidature/updateRDV', payload: {
                    rdvId: selectedRDV?._id, statut: rdvActionParameter,
                    emplacement, note, heureDebut, heureFin,
                    date: dateRdv
                }
            });
            handleCloseNestedInterviewerCandidature();
            // else if (rdvAction == rdvActionsEnum.replanifie) {
            //     postData({ url: '/candidature/replanifierRDV', payload: { test: '1771' } });
            // }
        }
    };

    {/*le client peut accepter un rendez-vous fixé /replanifié par le BackOffice*/ }
    {/* //! le client peut accepter un rdv replanifiee par le backOffice, si c est fixee, cad le backOffice a accepter ! */ }
    let conditionAcceptationRejet = (
        ((role == roleNameEnum.client || (role == roleNameEnum.esn && selectedRDV?.plannerEsnId && !selectedRDV?.readOnly))  && selectedRDV?.statut == 'replanifie' && selectedRDV?.lastPlanner == ROLES.Admin) ||
        (role == roleNameEnum.admin && (selectedRDV?.lastPlanner == ROLES.Client || (selectedRDV?.lastPlanner == ROLES.Esn && !selectedRDV?.selectedRDV))&&
            (selectedRDV?.statut == 'replanifie' || selectedRDV?.statut == 'planifie')));
    return (
        <form>
            <Dialog
                open={openNestedInterviewerCandidature}
                onClose={handleCloseNestedInterviewerCandidature}
                TransitionComponent={Transition}
                fullScreen
                scroll={'paper'}
                PaperProps={{
                    style: {
                        background: 'white',
                        paddingBottom: '24px'
                    },
                }}
                aria-labelledby="scroll-dialog-title"
                aria-describedby="scroll-dialog-description"
            >
                <AppBar>
                    <Toolbar>
                        <IconButton
                            edge="start"
                            color="inherit"
                            onClick={handleCloseNestedInterviewerCandidature}
                            aria-label="close"
                        >
                            <CloseIcon />
                        </IconButton>
                    </Toolbar>
                </AppBar>
                <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'center', paddingTop: '90px' }}>
                    <div className='createalertediv'>
                        <h4 className='titlesociete'>{i18n.t('Rendez-vous')} </h4>
                        <SelectComponent
                            name='emplacement'
                            label={i18n.t('Emplacement')}
                            val={emplacement}
                            setVal={(e) => {
                                setIsReplanning(true);
                                setEmplacement(e.target.value);
                            }}
                            disabled={(role == roleNameEnum.expert || (role==roleNameEnum.esn && selectedRDV?.plannerId && selectedRDV?.readOnly )) ? true : false}
                            listVal={EmplacementEnum}
                        />
                        {/*masquer v2*/}
                        {/*<GetZoomMeetingComponent
                            zoomLink={zoomLink}
                            setZoomLink={setZoomLink}
                            disabled={role == roleNameEnum.expert ? true : false}
                        />*/}
                        <div className="recherchepostetxtDiv">
                            <label className="recherchepostetxt">
                                {i18n.t('Note')}
                            </label>
                            <QuillAdvancedTextArea
                                placeholder='Entrer ici un commentaire... &#10;Tapez votre texte ici'
                                // ? si le backOffice la modifie, une notification envoyee a le sera suffisante
                                setValue={setNote}
                                setIsReplanning={setIsReplanning}
                                value={note}
                                readOnly={(role == roleNameEnum.expert || (role==roleNameEnum.esn && selectedRDV?.plannerId && selectedRDV?.readOnly )) ? true : false}

                            />
                        </div>
                        <div
                            className='recherchepostetxtDiv'
                            style={{ paddingTop: '90px' }}
                        >
                            <label className='recherchepostetxt'>{i18n.t('Date')}</label>
                            <DatePickerComponent
                                date={dateRdv ?? moment(selectedRDV?.date, 'DD-MM-YYYY hh:mm A') ??  selectedRDV?.date  }
                                name='date'
                                setDate={(newValue) => {
                                    setIsReplanning(true);
                                    setDateRdv(newValue);
                                }}
                                width={'100%'}
                                disabled={(role == roleNameEnum.expert || (role==roleNameEnum.esn && selectedRDV?.plannerId && selectedRDV?.readOnly )) ? true : false}
                            />
                        </div>
                        <div style={{ display: 'flex', flexDirection: 'row', alignSelf: 'stretch', gap: '8px' }}>
                            <div
                                className='recherchepostetxtDiv'
                                style={{ width: '50%' }}
                            >
                                <label className='recherchepostetxt'>{i18n.t('Heure de début')}</label>
                                <TextFieldComponent
                                    id="time"
                                    type="time"
                                    style={{ width: '100%', borderRadius: '8px', background: 'white' }}
                                    name='heureDebut'
                                    onChange={(e) => {
                                        setIsReplanning(true);
                                        setHeureDebut(e.target.value);
                                    }}
                                    value={heureDebut}
                                    disabled={(role == roleNameEnum.expert || (role==roleNameEnum.esn && selectedRDV?.plannerId && selectedRDV?.readOnly )) ? true : false}
                                />
                            </div>
                            <div
                                className='recherchepostetxtDiv'
                                style={{ width: '50%' }}
                            >
                                <label className='recherchepostetxt'>{i18n.t('Heure de fin')}:</label>
                                <TextFieldComponent
                                    id="time"
                                    type="time"
                                    style={{ width: '100%', borderRadius: '8px', background: 'white' }}
                                    name='heureFin'
                                    onChange={(e) => {
                                        setIsReplanning(true);
                                        setHeureFin(e.target.value);
                                    }}
                                    value={heureFin}
                                    disabled={(role == roleNameEnum.expert || (role==roleNameEnum.esn && selectedRDV?.plannerId&& selectedRDV?.readOnly )) ? true : false}
                                />
                            </div>
                        </div>
                        <>
                            {/* //? this div is for actions */}
                            <div className='btnsinterview'>
                                {((role == roleNameEnum.client ||(role == roleNameEnum.esn && !selectedRDV?.readOnly))  && statusCandidature == 'interview') &&
                                    <Button
                                        type='submit'
                                        style={{
                                            ...buttonStylesGreen(false), ...{ width:device=='desktop'?'100px':'100%'}
                                        }}
                                        onClick={(e) => {
                                            e.preventDefault();
                                            if (isValid) {
                                                handleSendRdv();
                                                setShowErrors(false);
                                                setErrors({});
                                            }
                                            else setShowErrors(true);
                                        }}
                                    >{i18n.t('Planifier')}</Button>
                                }
                                {
                                    selectedRDV &&
                                    <>
                                        {conditionAcceptationRejet &&
                                            <Button
                                                //style={{ ...buttonStyles() }}
                                                style={{
                                                    ...buttonStyles(),...{color:'#EC5B56',borderColor:'#EC5B56',width:device=='desktop'?'auto':'100%'}
                                                }}
                                                variant="outlined"
                                                //color="error"
                                                onClick={() => {
                                                    handleSendRdv(rdvActionsEnum.rejete);
                                                }}
                                                disabled={isReplanning}
                                            >
                                                {i18n.t('Rejeter')}
                                            </Button>
                                        }
                                        {(selectedRDV?.date && (role == roleNameEnum.admin || (role== roleNameEnum.esn && selectedRDV?.plannerEsnId && !selectedRDV?.readOnly) ||
                                        role == roleNameEnum.client) //&&statusCandidature !== 'interview'
                                        ) &&
                                            <Button
                                                disabled={!isReplanning}
                                                variant="text"
                                                startIcon={<IconReplanification color={((!isReplanning) ? '#C3C9F1':'#214DCE')} />}
                                                style={{ ...buttonStyles((!isReplanning)),...{width:device=='desktop'?'auto':'100%'}}}
                                                onClick={() => {
                                                    handleSendRdv(rdvActionsEnum.replanifie);
                                                }}
                                            >
                                                {i18n.t('Replanifier')}
                                            </Button>
                                        }
                                        {conditionAcceptationRejet &&
                                            <Button
                                                className='cancelalerte'
                                                variant="outlined"
                                                //color="success"
                                                style={{ ...buttonStylesGreen(),...{width:device=='desktop'?'auto':'100%'} }}
                                                disabled={isReplanning}
                                                onClick={() => {
                                                    handleSendRdv(rdvActionsEnum.accepte);
                                                }}
                                            //PS : to discuss with reda -> pour ajouter la fonctionnalite 'Accepter le RDV' chez le client(cas de replanification par l'admin )
                                            >{i18n.t('Accepter')}</Button>
                                        }
                                        {((role == roleNameEnum.client || (role== roleNameEnum.esn && selectedRDV?.plannerEsnId && !selectedRDV?.readOnly)) &&
                                        //? soit les condition d'acceptation ou rejet ( c'etait pas lui le dernier qui a planifie)
                                        (conditionAcceptationRejet ||
                                        //? soit on est sur le cas de replanifier, mais pour le role client ( admin could not annuler rdv)
                                        selectedRDV?.date)) &&
                                        //&& statusCandidature !== 'interview'
                                            <Button
                                                // variant="outlined"
                                                style={{ ...buttonStyles(),
                                                    ...{
                                                        borderColor: '#EC5B56', color: '#EC5B56',width:device=='desktop'?'auto':'100%'
                                                    } }}
                                                onClick={() => {
                                                    handleSendRdv(rdvActionsEnum.annule);
                                                }}
                                            >
                                                {i18n.t('Annuler le rendez-vous')}
                                            </Button>
                                        }
                                    </>
                                }
                            </div>
                        </>
                    </div>
                </div>
            </Dialog>
        </form>
    );
}

export default DialogInterviewerCandidature;
